<template>
  <div id="row_0" class="error-500-cont">
    <div class="grid-x align-center">
      <div v-if="deviceType === 'PHONE'" class="cell small-device">
        <img class="img-adaptive stretch poolAssets" :src="`${assetHost}/page/home-page/latest/images/evergreen.png`" alt="man woman and bag" />
        <div id="b-hp-footer-links" class="row">
          <div class="small-12 columns">
            <a href="/shop/coupons-sales-promotions" aria-label="Promotions">
              <div class="b-hp-footer-promotions b-hp-footer-links-img">Promotions</div>
            </a>
          </div>
          <div class="small-12 columns">
            <a href="//locations.bloomingdales.com/store-locator" aria-label="Find a store">
              <div class="b-hp-footer-store b-hp-footer-links-img">Find a store</div>
            </a>
          </div>
        </div>
      </div>

      <div v-else class="medium-device cell">
        <map name="adMap2016562">
          <area
            alt="Shop Men"
            coords="497,0,828,462"
            href="/shop/mens?id=3864&amp;cm_sp=n_n_homepage_1-_-row1_imagemap_n-_-GEOR0__shop-men"
            shape="rect"
          />
          <area
            alt="Shop Women"
            coords="10,10,447,463"
            href="/shop/womens-apparel?id=2910&amp;cm_sp=n_n_homepage_1-_-row1_imagemap_n-_-GEOR0__shop-women"
            shape="rect"
          />
        </map>
        <img
          class="img-adaptive stretch"
          :src="`${assetHost}/page/home-page/latest/images/default_homepage-bcom.jpg`"
          alt="shop mens and womens"
          width="960"
          height="463"
          usemap="#adMap2016562"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useEnvProps } from '@/stores/envProps';
const envPropsStore = useEnvProps();
const assetHost = computed(() => envPropsStore?.envProps?.navigationAssetHost ?? '');
const deviceType = computed(() => envPropsStore?.envProps?.headers?.deviceType);
const promotionsImage = `url(${assetHost.value}/page/home-page/latest/images/promotions.png)`;
const findAStoreImage = `url(${assetHost.value}/page/home-page/latest/images/findastore.png)`;
</script>

<style lang="scss" scoped>
.error-500-cont {
  #b-hp-footer-links {
    border-bottom: 2px solid #000;
    border-top: 2px solid #000;
    padding: rem-calc(10px) 0;
    text-align: center;
    .b-hp-footer-promotions,
    .b-hp-footer-store {
      text-indent: -999em;
      background-position: 50%;
      background-repeat: no-repeat;
      height: rem-calc(40px);
      width: rem-calc(130px);
      margin: 0 auto;
    }
    .b-hp-footer-promotions {
      background-image: v-bind(promotionsImage);
      background-size: 68%;
    }
    .b-hp-footer-store {
      background-image: v-bind(findAStoreImage);
      background-size: 68%;
    }
  }

  img {
    max-width: 100%;
    width: 100%;
    height: auto;
  }
}
</style>
